import { AppDispatch } from "../store";
import { showLoader, hideLoader, resetLoader } from "../Slices/loaderSlice";

let appDispatch: AppDispatch | null = null;

export const setAppDispatch = (dispatch: AppDispatch) => {
  appDispatch = dispatch;
};

export const dispatchStartLoading = () => {
  if (appDispatch) appDispatch(showLoader());
};

export const dispatchStopLoading = () => {
  if (appDispatch) appDispatch(hideLoader());
};

export const dispatchResetLoader = () => {
  if (appDispatch) appDispatch(resetLoader());
};
